<template>
	<div v-if="userPwd.isPwdShow">
	    <!-- 重置子账号密码弹窗 -->
	    <div class="mask re-password user-center-modal">
	        <div class="e-modal small">
	            <div class="e-modal-title">Reset the password of the subaccount <i class="e-modal-close" @click="userPwd.isPwdShow=false"></i></div>
	            <div class="e-modal-body">
	                <div class="e-form">
	                    <div class="form-contorl">
	                        <label class="title">New password：</label>
	                        <input type="password" v-model="Pwd" />
	                    </div>
	                    <div class="form-contorl">
	                        <label class="title">Confirm password：</label>
	                        <input type="password" v-model="Pwd2" />
	                    </div>
	                </div>
	            </div>
	            <div class="e-modal-footer">
	                <div class="long-btn save-btn" @click="save">save</div>
	                <div class="long-btn cancel-btn" @click="userPwd.isPwdShow=false">cancel</div>
	            </div>
	        </div>
	    </div>
	</div>
</template>
<script>
	export default{
		name:'resetPassword',
		props:{
			userPwd:{
				type:Object,
				default:function(){
					return{}
				}
			}
		},
		data(){
			return{
				Pwd:'',
				Pwd2:''
			}
		},
		methods:{
			save(){
				var that=this;
				var Pwd=that.Pwd;
				var Pwd2=that.Pwd2;
				if(!Pwd){
		            that.error({title: 'Create error',content: 'Please enter new password'})
            		return;
				}
				if(Pwd.length<6||Pwd.length>32){
		            that.error({title: 'Create error',content: 'The password contains a minimum of 6 characters and a maximum of 32 characters'})
            		return;
				}

				if(!Pwd2){
		            that.error({title: 'Create error',content: 'Please enter confirmation password'})
            		return;
				}

				if(Pwd!=Pwd2){
		            that.error({title: 'Create error',content: 'The two password entries are different'})
            		return;
				}

				var params={
					NO:this.userPwd.NO,
					IsActive:null,
					Pwd:Pwd==Pwd2?Pwd:'',
					Permissions:'',
					Hotels:null
				}
				
			
	            that.patchRequest({
	                url: that.Api.eidtSubUser,
	                params:params
	            }).then(res => {
	                if (res&&res.IsSuccess) {
	                    that.error({ title: 'Tips', content: 'Update successfully' });
	                	that.userPwd.isPwdShow=false;
	                	that.$emit('done')
	                } else {
	                    that.error({ title: 'Tips', content: 'Update error, please try again' });
	                }
	            });
			}
		}

	}
</script>


// WEBPACK FOOTER //
// src/components/user/ResetPassword.vue